import TableEmptyState from './TableEmptyState.component';

export default TableEmptyState;